// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-bar {
    margin-top: 20px;
}

.progress-bar--outer {
    background: var(--theia-editorWidget-background);
    border-radius: 11px;
    height: 6px;
    position: relative;
    overflow: hidden;
}

.progress-bar--inner {
    transition: width 1s;
    height: 100%;
    background: var(--theia-progressBar-background);
    border-radius: 11px;
}

.progress-bar--percentage {
    align-items: flex-end;
    display: flex;
    height: 40px;
    justify-content: center;
    margin-top: 10px;
    width: 100%;
}

.progress-bar--percentage-text {
    font-size: 14px;
    line-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/progress-bar.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".progress-bar {\r\n    margin-top: 20px;\r\n}\r\n\r\n.progress-bar--outer {\r\n    background: var(--theia-editorWidget-background);\r\n    border-radius: 11px;\r\n    height: 6px;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.progress-bar--inner {\r\n    transition: width 1s;\r\n    height: 100%;\r\n    background: var(--theia-progressBar-background);\r\n    border-radius: 11px;\r\n}\r\n\r\n.progress-bar--percentage {\r\n    align-items: flex-end;\r\n    display: flex;\r\n    height: 40px;\r\n    justify-content: center;\r\n    margin-top: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.progress-bar--percentage-text {\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
